import { module } from 'modujs';
import { debounce } from '../utils/tickers';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        
        this.cards = this.el.querySelectorAll('.offers_card_content');
        
        this.sameHeight();
        window.addEventListener(
            "resize",
            debounce(() => {
                this.sameHeight()
            }, 10, false)
        );
    }

    sameHeight() {
        let heights = [];

        for (var i = 0; i < this.cards.length; i++) {
            this.cards[i].setAttribute('style', '');
        }
    
        for (var i = 0; i < this.cards.length; i++) {
            heights.push(this.cards[i].offsetHeight);
        }

        let tallest = Math.max(...heights);
    
        for (var i = 0; i < this.cards.length; i++) {
            this.cards[i].style.height = tallest + "px";
        }

        setTimeout(() => {
            this.call('resize', 'Scroll');
        }, 100);
    }
}
